import { render, staticRenderFns } from "./inspections.vue?vue&type=template&id=0b65210d&scoped=true&"
import script from "./inspections.vue?vue&type=script&lang=js&"
export * from "./inspections.vue?vue&type=script&lang=js&"
import style0 from "./inspections.vue?vue&type=style&index=0&id=0b65210d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b65210d",
  null
  
)

export default component.exports